<template>
    <div class="d-flex justify-content-center align-items-center" style="height: 3em;">
        <span class="label label-xl label-inline text-capitalize user-select-none"
              :style="role !== undefined ? roleLabel(role.color) : ''">
            <i class="fas fa-user-lock mr-2"></i><span>{{ getTranslated(role) }}</span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'StoreRole',

    props: {
        role: Object
    },

    methods: {
        roleLabel(hexCode) {
            if (hexCode === null) {
                return ''
            }

            let color = hexToRgb(hexCode)

            return `background-color:rgba(${color.r},${color.g},${color.b},0.15);color:#${hexCode};`
        },

        getTranslated(role){
            if(role === undefined){
                return '';
            }

            if(!role.custom){
                return this.__('general.roles.' + role.name)
            }

            return role.name;
        }
    },
}
</script>
